import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {
  JobHazardAnalysisSimpleResponse,
  JobHazardAnalysisStateEnum,
} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {JobHazardAnalysisStateDataOptions} from 'src/shared/constants/columnFilterData';
import {JobHazardAnalysisPillConfig} from 'src/app/job-hazard-analysis/jobHazardAnalysisHelpers';

export const useJobHazardAnalysisColumns = () => {
  const columns = useMemo<MRT_ColumnDef<JobHazardAnalysisSimpleResponse>[]>(
    () => [
      {
        accessorKey: 'internalIdentifier',
        header: 'ID',
      },
      {
        accessorKey: 'subjectName',
        header: 'Subject',
      },
      {
        accessorKey: 'creatorName',
        header: 'Creator',
      },
      {
        accessorKey: 'approverName',
        header: 'Approver',
      },
      {
        accessorKey: 'safetyReviewerName',
        header: 'Safety Reviewer',
      },
      {
        accessorKey: 'state',
        header: 'Status',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: JobHazardAnalysisStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<JobHazardAnalysisStateEnum>();
          const pills = JobHazardAnalysisPillConfig(cellValue);
          if (!pills.length) return null;
          return <Pill text={pills[0].text} color={pills[0].color} />;
        },
      },
      {
        accessorKey: 'workStartDate',
        header: 'Work Start',
        Cell: ({cell}) => {
          const val = cell.getValue<Date>();
          if (!val) return null;
          return new Date(val).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          });
        },
      },
      {
        accessorKey: 'workFinishDate',
        header: 'Work Finish',
        Cell: ({cell}) => {
          const val = cell.getValue<Date>();
          if (!val) return null;
          return new Date(val).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          });
        },
      },
      {
        accessorKey: 'location',
        header: 'Location',
      },
    ],
    []
  );

  return columns;
};
